import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    loading: false,
    error: null,
    recycleLeadListResponse: null,
    data: null
};

//UPLOAD-LEAD-CSV-PDF-START

export const uploadLeadCsv = createAsyncThunk(
    "uploadLeadCsv",
    async (body) => {
        try {

            const response = await instance.post("/crm/recycle-lead/upload-all-lead", body);
            return response?.data;
        } catch (error) {
            return error;
        }
    },
);
// create pull lead
export const createPullLead = createAsyncThunk(
    "createPullLead",
    async (body) => {
        try {

            const response = await instance.post("/crm/recycle-lead/fetch-lead-on-import-lead", body);
            return response?.data;
        } catch (error) {
            return error;
        }
    },
);
//UPLOAD-LEAD-CALENDER-PDF-END

export const GetRecycleLeadList = createAsyncThunk(
    "GetRecycleLeadList",
    async (body) => {
        try {
            const response = await instance.get(`crm/recycle-lead/get-all-new-lead?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)

export const ImportAndRecycleLeadSlice = createSlice({
    name: "ImportAndRecycleLeadSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(uploadLeadCsv.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(uploadLeadCsv.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(uploadLeadCsv.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(createPullLead.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createPullLead.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
        });
        builder.addCase(createPullLead.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(GetRecycleLeadList.pending, (state) => {
            state.loading = true;
            state.recycleLeadListResponse = null;
            state.data = null;
        });
        builder.addCase(GetRecycleLeadList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(GetRecycleLeadList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

    },
});

export default ImportAndRecycleLeadSlice.reducer;